<template>
  <div title="Send us an enquiry" :class="iconClasses" @click.prevent="redirectTo('enquiry')" />
</template>

<script>
import routerLink from '../../../mixins/routerLink';
import closeTab from '../../../mixins/closeTab';

export default {
  mixins: [routerLink, closeTab],
  props: {
    white: { type: Boolean },
  },
  computed: {
    iconClasses() {
      return {
        enquiryicon: true,
        'enquiryicon-blue': !this.white,
        'enquiryicon-white': this.white,
        inactive: !this.isEnquiryPage,
        active: this.isEnquiryPage,
      };
    },
    isEnquiryPage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].id == 41 || this.$store.getters['pages/currentPage'].id == 43 : false;
    },
    isShortlistEmpty() {
      return this.$store.getters['common/getShortlist'].length === 0;
    },
    currentRedirectSection() {
      return this.$store.getters['common/getCurrentRedirectSection'];
    },
  },
  created() {
    this.updateEnquiry();
    this.resetEnquiry();
  },
  methods: {
    redirectTo(pagename) {
      this.closeTab(null);
      this.isShortlistEmpty ? this.$router.push({ path: this.$store.getters['applinks/getLink']('page', 43).url }) : this.$router.push({ path: this.$store.getters['applinks/getLink']('page', 41).url });
      window.scrollTo(0, 0);
      // does not seem like we need these
      this.$store.commit('common/setCurrentRedirectSection', pagename);
      window.$cookies.set('currentRedirectSection', 'enquiry', 2147483647);
    },
    updateEnquiry() {
      // update
      if (/enquiry|demande|anfrage|my-enquiry-list|ma-selection|meine-anfrageliste/.test(window.location.href)) {
        this.$store.commit('common/setCurrentRedirectSection', 'enquiry');
      }
    },
    resetEnquiry() {
      // reset
      if (!/enquiry|demande|anfrage|my-enquiry-list|ma-selection|meine-anfrageliste/.test(window.location.href) && window.$cookies.get('currentRedirectSection')) {
        window.$cookies.set('currentRedirectSection', '', 2147483647);
      }
    },
  },
};
</script>

<style lang="scss">
  @import "../../../assets/styles/settings/config.scss";

  .enquiryicon {
    width: 24px;
    height: 19px;
  }

  .enquiryicon-blue {
    &.active {
      background-image: svg-load("icons/enquiry-active-icon.svg", fill=#050817);
    }
    &.inactive {
     background-image: svg-load("icons/enquiry-inactive-icon.svg", fill=#050817);
    }
  }

  .enquiryicon-white {
    &.active {
      background-image: svg-load("icons/enquiry-active-icon.svg", fill=#ffffff);
    }
    &.inactive {
     background-image: svg-load("icons/enquiry-inactive-icon.svg", fill=#ffffff);
    }
  }

</style>
